import Component from '@glimmer/component';
import { action } from '@ember/object';
import BulkActionModel from 'donor-elf-web/models/bulk-action';

interface ComponentArgs {
  bulkAction: BulkActionModel;
  onStatusChange: (bulkAction: BulkActionModel) => void;
}

const PollInterval = 1500;

export default class BulkActionPollForStatusChangeComponent extends Component<ComponentArgs> {
  constructor(owner: any, args: ComponentArgs) {
    super(owner, args);

    this.intervalId = window.setInterval(() => {
      this.reloadModel();
    }, PollInterval);
  }

  intervalId?: number;

  @action
  async reloadModel() {
    let previousStatus = this.args.bulkAction.status;
    await this.args.bulkAction.reload();
    if (previousStatus !== this.args.bulkAction.status) {
      this.args.onStatusChange(this.args.bulkAction);
      if (
        this.args.bulkAction.status === 'completed' ||
        this.args.bulkAction.status === 'error'
      ) {
        this.clearInterval();
      }
    }
  }

  @action
  clearInterval() {
    if (this.intervalId) {
      window.clearInterval(this.intervalId);
      this.intervalId = undefined;
    }
  }

  @action
  templateWillDestroy() {
    this.clearInterval();
  }
}
